import script from "./devotion-card.vue?vue&type=script&setup=true&lang=js"
export * from "./devotion-card.vue?vue&type=script&setup=true&lang=js"

import "./devotion-card.vue?vue&type=style&index=0&id=635cb950&lang=css"

const __exports__ = script;

export default __exports__